import {GlobalNotification} from '../../../../../@backend/modules/@users/models/global-notification.model';
import {Component, Inject, NgZone, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationDialogComponent implements OnInit {

  public type: string;
  public title: string;
  public message: string;
  public activeStartDatetime: Date;

  constructor(private zone: NgZone, @Inject(MAT_DIALOG_DATA)
              public data: GlobalNotification,
              private dialogRef: MatDialogRef<NotificationDialogComponent>) {

    this.type = data.notificationType;
    this.title = data.notificationTitle;
    this.message = data.notificationMessageContent;
    this.activeStartDatetime = data.activeStartDatetime;
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();

  }
}
